import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import '@/styles/app.css';
import '@/styles/clarity.css';
/* After clarity: the person's Glass look must outrank its borderless cards, and only in Glass. */
import '@/styles/glass.css';
/* After glass: Granite is glass with a grain, and its rules outrank Glass's. */
import '@/styles/granite.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
